<template>
  <a-modal :title="title" :visible="visible" :width="1050" :maskClosable="false" :footer="null" @cancel="handleClose">
    <div class="display-setting">
      <!-- 左：手机壳实时预览 -->
      <div class="preview-wrap">
        <div class="phone-shell">
          <div class="phone-screen">
            <div class="mall-nav">
              <a-icon type="left" />
              <span class="mall-nav-title">{{ materialName }}</span>
              <a-icon type="ellipsis" />
            </div>
            <div class="phone-body">
              <div class="goods-main-img">
                <a-carousel v-if="mainImgs.length" autoplay dots-class-name="slick-dots">
                  <div v-for="(img, i) in mainImgs" :key="i" class="carousel-item">
                    <img :src="imgUrl(img)" />
                  </div>
                </a-carousel>
                <div v-else class="img-placeholder">暂无主图<br/>请在右侧上传</div>
              </div>
              <div class="goods-info">
                <div class="goods-name">{{ materialName }}</div>
                <div class="goods-price">¥ --</div>
              </div>
              <div class="detail-title">—— 商品详情 ——</div>
              <div class="goods-detail">
                <template v-if="detailImgs.length">
                  <img v-for="(img, i) in detailImgs" :key="i" :src="imgUrl(img)" />
                </template>
                <div v-else class="img-placeholder">暂无详情图<br/>请在右侧上传</div>
              </div>
            </div>
          </div>
        </div>
        <div class="preview-tip">手机端实时预览</div>
      </div>
      <!-- 右：设置表单 -->
      <div class="form-wrap">
        <a-form-item label="商城上架" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18, offset: 1 }">
          <a-switch :checked="onShelf === '1'" @change="onShelfChange" />
          <span class="shelf-tip">{{ onShelf === '1' ? '已上架，会员商城可见' : '未上架，商城不显示' }}</span>
        </a-form-item>
        <a-form-item label="主图" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18, offset: 1 }">
          <j-image-upload v-model="imgName" bizPath="material" text="上传主图" isMultiple></j-image-upload>
          <div class="field-tip">商城列表与详情页顶部轮播，建议正方形，最多4张</div>
        </a-form-item>
        <a-form-item label="详情图" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18, offset: 1 }">
          <j-image-upload v-model="imgDetail" bizPath="material" text="上传详情图" isMultiple></j-image-upload>
          <div class="field-tip">详情页长图，按上传顺序纵向排列</div>
        </a-form-item>
        <div class="form-footer">
          <a-button @click="handleClose">取消</a-button>
          <a-button type="primary" :loading="saving" style="margin-left: 8px" @click="handleSave">保存</a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import { getFileAccessHttpUrl } from '@/api/manage'
  import { goodsDisplayGet, goodsDisplaySave } from '@/api/plugin/member'

  /**
   * 商城展示设置（所见即所得）：左侧手机壳预览 + 右侧上架/主图/详情图
   */
  export default {
    name: 'GoodsDisplaySetting',
    components: { JImageUpload },
    data() {
      return {
        title: '商城展示设置',
        visible: false,
        materialId: null,
        materialName: '',
        onShelf: '0',
        imgName: '',
        imgDetail: '',
        saving: false
      }
    },
    computed: {
      mainImgs() {
        return this.splitImgs(this.imgName)
      },
      detailImgs() {
        return this.splitImgs(this.imgDetail)
      }
    },
    methods: {
      splitImgs(value) {
        return value ? value.split(',').filter(s => s && s.trim()) : []
      },
      imgUrl(path) {
        return getFileAccessHttpUrl('systemConfig/static/' + path)
      },
      open(record) {
        this.materialId = record.id
        this.materialName = record.name
        this.title = '商城展示设置 - ' + record.name
        this.visible = true
        this.load()
      },
      load() {
        goodsDisplayGet(this.materialId).then((res) => {
          if (res && res.code === 200) {
            const data = res.data || {}
            this.onShelf = data.onShelf || '0'
            this.imgName = data.imgName || ''
            this.imgDetail = data.imgDetail || ''
          } else {
            this.$message.warning((res && res.message) || '加载失败')
          }
        })
      },
      onShelfChange(checked) {
        this.onShelf = checked ? '1' : '0'
      },
      handleSave() {
        this.saving = true
        goodsDisplaySave(this.materialId, {
          onShelf: this.onShelf,
          imgName: this.imgName,
          imgDetail: this.imgDetail
        }).then((res) => {
          if (res && res.code === 200) {
            this.$message.success('保存成功')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.warning((res && res.message) || '保存失败')
          }
        }).finally(() => {
          this.saving = false
        })
      },
      handleClose() {
        this.visible = false
      }
    }
  }
</script>

<style scoped>
  .display-setting {
    display: flex;
  }
  .preview-wrap {
    width: 340px;
    flex-shrink: 0;
    text-align: center;
  }
  .phone-shell {
    width: 300px;
    height: 560px;
    margin: 0 auto;
    border: 10px solid #333;
    border-radius: 30px;
    background: #333;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .2);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .phone-screen {
    flex: 1;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 2px;
  }
  .mall-nav {
    height: 40px;
    background: #0081ff;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    flex-shrink: 0;
  }
  .mall-nav-title {
    font-size: 14px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .phone-body {
    flex: 1;
    overflow-y: auto;
  }
  .goods-main-img {
    height: 220px;
    background: #fff;
  }
  .goods-main-img .carousel-item {
    height: 220px;
  }
  .goods-main-img img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    display: block;
  }
  .img-placeholder {
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #bbb;
    font-size: 13px;
    text-align: center;
    line-height: 1.8;
    background: #fafafa;
  }
  .goods-info {
    background: #fff;
    padding: 10px 12px;
    margin-bottom: 8px;
  }
  .goods-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
  .goods-price {
    margin-top: 6px;
    color: #e4393c;
    font-size: 16px;
    font-weight: 600;
  }
  .detail-title {
    text-align: center;
    color: #999;
    font-size: 12px;
    padding: 6px 0;
    background: #f5f5f5;
  }
  .goods-detail img {
    width: 100%;
    display: block;
  }
  .goods-detail .img-placeholder {
    height: 120px;
  }
  .preview-tip {
    margin-top: 8px;
    color: #999;
    font-size: 12px;
  }
  .form-wrap {
    flex: 1;
    margin-left: 30px;
    padding-top: 10px;
  }
  .shelf-tip {
    margin-left: 10px;
    color: #999;
    font-size: 12px;
  }
  .field-tip {
    color: #999;
    font-size: 12px;
    margin-top: 4px;
  }
  .form-footer {
    text-align: right;
    margin-top: 16px;
    border-top: 1px solid #e8e8e8;
    padding-top: 12px;
  }
</style>
